module.exports = __webpack_public_path__ + "static/media/giphy-0.11e70b9e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/giphy-0.gif
// module id = 171
// module chunks = 0